/** @jsx $jsx */
import { $jsx } from 'framework7';
import { setup } from '../../js/app';
import resolvedConfig from '../../js/config';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on,
      $f7router = _ref.$f7router,
      $update = _ref.$update,
      $store = _ref.$store;
  var selected = 'home';
  var selectedMedia = 'home';
  var toastBottom;
  var token = $store.getters.token;

  var setItem = function setItem(newItem) {
    selected = newItem;
    $update();
  };

  var setItemMedia = function setItemMedia(newItem) {
    selectedMedia = newItem;
    $update();
  };

  var resolveVisualizerURL = function resolveVisualizerURL() {
    // const url = 'https://pera-swarm.ce.pdn.ac.lk/visualizer/?key=';
    var url = 'https://pera-swarm.github.io/visualizer/?key=';
    var storedConfig = localStorage.getItem(document.location.origin + '.config'); // console.log('VISUALIZER', token.value);

    if (token !== undefined && token !== null && token.value) {
      return url + token.value;
    } else {
      return '#';
    }
  };

  var clearCache = function clearCache() {
    $store.dispatch('clearLogs');
  }; // console.log(
  //     window.isAuthenticated,
  //     JSON.parse(localStorage.getItem(document.location.origin))
  // );


  var _window$mqtt = window.mqtt,
      channel = _window$mqtt.channel,
      client = _window$mqtt.client; // console.log($f7, $on, $f7router, window.mqtt, resolvedConfig);

  var showToastBottom = function showToastBottom(message) {
    // Create toast
    if (!toastBottom) {
      toastBottom = $f7.toast.create({
        text: message,
        closeTimeout: 4000,
        position: "bottom",
        horizontalPosition: "center"
      });
    } // Open it


    toastBottom.open();
  };

  $on('pageInit', function (e, page) {
    setup(showToastBottom);
  });
  $on('pageBeforeRemove', function () {
    if (toastBottom) toastBottom.destroy();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page" data-name="colorSensor">
        <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner sliding">
                <div class="title">Sandbox</div>
            </div>
        </div>
        <!-- Config Page Content -->
        <div class="page-content">
            <div class="container pt-2">
                <!-- <h3>Neo Pixel LED Ring</h3> -->
                <!-- Color Control -->
                <div class="block-title">Current Settings (2)</div>
                <div class="card p-2">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="list inline-labels">
                                <ul>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">tray_2</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                Server
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt_server"
                                                    type="text"
                                                    placeholder="MQTT Server"
                                                    disabled="{true}"
                                                    value="${client.host}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">textformat_123</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">Port</div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt_port"
                                                    type="text"
                                                    placeholder="MQTT Port"
                                                    disabled="{true}"
                                                    value="${client.port}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">number_square</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                ClientID
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt_client_id"
                                                    type="text"
                                                    placeholder="MQTT Client ID"
                                                    disabled="{true}"
                                                    value="${client.clientId}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons"
                                                >dot_radiowaves_left_right</i
                                            >
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                Channel
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt_channel"
                                                    type="text"
                                                    placeholder="MQTT Channel"
                                                    disabled="{true}"
                                                    value="${channel}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">wifi</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                Is Connected?
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="status"
                                                    type="text"
                                                    placeholder="Connection Status"
                                                    disabled="{true}"
                                                    value="${window.isAuthenticated}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <button
                                    class="button button-raised button-fill color-green popup-open my-2"
                                    data-popup=".popup-services"
                                >
                                    Change
                                </button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="block-title">Authentication</div>
                            <div class="list inline-labels">
                                <ul>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">person</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                Username
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt-username"
                                                    type="text"
                                                    placeholder="MQTT Username"
                                                    value="${window.username}"
                                                    disabled="${window.isAuthenticated}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input">
                                        <div class="item-media">
                                            <i class="icon f7-icons">lock</i>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title item-label">
                                                Password
                                            </div>
                                            <div class="item-input-wrap">
                                                <input
                                                    id="mqtt-password"
                                                    type="password"
                                                    placeholder="MQTT Password"
                                                    value="${window.password}"
                                                    disabled="${isAuthenticated}"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                ${window.isAuthenticated === true ?
                                <button
                                    class="button button-raised button-fill color-red my-2 disconnect-button-cls"
                                    id="disconnect-button"
                                >
                                    Disconnect
                                </button>
                                :
                                <button
                                    class="button button-raised button-fill color-blue my-2"
                                    id="connect-button"
                                >
                                    Connect
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Settings Form Pop Up -->
                <div class="popup popup-services">
                    <div class="page-content container p-2">
                        <div class="block">
                            <div class="card col">
                                <div class="list inline-labels mt-5">
                                    <ul>
                                        <li class="item-content item-input">
                                            <div class="item-media">
                                                <i class="icon f7-icons">tray_2</i>
                                            </div>
                                            <div class="item-inner">
                                                <div class="item-title item-label">
                                                    Server
                                                </div>
                                                <div class="item-input-wrap">
                                                    <input
                                                        type="text"
                                                        placeholder="MQTT Server"
                                                        value="${client.host}"
                                                        id="input-server"
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input">
                                            <div class="item-media">
                                                <i class="icon f7-icons"
                                                    >textformat_123</i
                                                >
                                            </div>
                                            <div class="item-inner">
                                                <div class="item-title item-label">
                                                    Port
                                                </div>
                                                <div class="item-input-wrap">
                                                    <input
                                                        type="text"
                                                        placeholder="MQTT Port"
                                                        value="${client.port}"
                                                        id="input-port"
                                                    />
                                                    <div class="item-input-info">
                                                        (Default: 8883)
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input">
                                            <div class="item-media">
                                                <i class="icon f7-icons">number_square</i>
                                            </div>
                                            <div class="item-inner">
                                                <div class="item-title item-label">
                                                    ClientID
                                                </div>
                                                <div class="item-input-wrap">
                                                    <input
                                                        type="text"
                                                        placeholder="MQTT Client ID"
                                                        disabled
                                                        id="input-client-id"
                                                        value="${client.clientId}"
                                                    />
                                                    <div class="item-input-info">
                                                        (Automatically generated)
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input">
                                            <div class="item-media">
                                                <i class="icon f7-icons"
                                                    >dot_radiowaves_left_right</i
                                                >
                                            </div>
                                            <div class="item-inner">
                                                <div class="item-title item-label">
                                                    Channel
                                                </div>
                                                <div class="item-input-wrap">
                                                    <input
                                                        type="text"
                                                        placeholder="MQTT Channel"
                                                        id="input-channel"
                                                        value="${channel}"
                                                    />
                                                    <div class="item-input-info">
                                                        (Default: v1)
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="row m-3 pt-5">
                                        <div class="col col-md-8"></div>
                                        <div class="col col-md-2">
                                            <button
                                                class="button button-raised button-fill color-red popup-close"
                                                data-popup=".popup-services"
                                            >
                                                Close
                                            </button>
                                        </div>
                                        <div class="col col-md-2">
                                            <button
                                                class="button button-raised button-fill color-primary settings-popup-save-button"
                                                data-popup=".popup-services"
                                                id="settings-popup-save-button-1"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Settings Form Pop Up -->
            </div>
        </div>
        <!-- End Config Page Content -->
    </div>
`
    }
    ;
});